<template>
    <tr v-if="edit === true">
      <td>
        {{ index + 1 }}
      </td>
      <td>
        <input
          class="input"
          v-bind:class="{ 'is-danger': $v.date.$error }"
          type="datetime-local"
          step="1"
          v-model="$v.date.$model"
        >
        <p v-if="$v.date.$error" class="help is-danger">This value is invalid</p>
      </td>
      <td>
        <input
          class="input"
          v-bind:class="{ 'is-danger': $v.row.odometer.$error }"
          type="number"
          step="1"
          v-model="$v.row.odometer.$model"
        >
        <p v-if="$v.row.odometer.$error" class="help is-danger">This value is invalid</p>
      </td>
      <td>
        <input
          class="input"
          v-bind:class="{ 'is-danger': $v.row.liters.$error }"
          type="number"
          step="0.01"
          v-model="$v.row.liters.$model"
        >
        <p v-if="$v.row.liters.$error" class="help is-danger">This value is invalid</p>
      </td>
      <td>
        <input
          class="input"
          v-bind:class="{ 'is-danger': $v.row.price.$error }"
          type="number"
          step="0.01"
          v-model="$v.row.price.$model"
        >
        <p v-if="$v.row.price.$error" class="help is-danger">This value is invalid</p>
      </td>
      <td>
        <div class="buttons">
          <button class="button is-outlined is-primary" @click="updateEntry">
            <font-awesome-icon icon="save" size="1x"/>
          </button>
          <button class="button is-outlined is-danger" @click="cancelEdit">
            <font-awesome-icon icon="window-close" size="1x"/>
          </button>
        </div>
      </td>
    </tr>

    <tr v-else>
      <td>{{ index + 1 }}</td>
      <td>{{ row.date }}</td>
      <td>{{ row.odometer | distance }}</td>
      <td>{{ row.liters | volume }}</td>
      <td>{{ row.price | price}}</td>
      <td>
        <div class="buttons">
          <button class="button is-outlined is-primary" @click="toggleEndOfSequence">
            <font-awesome-icon icon="stop" size="1x"/>
          </button>

          <button class="button is-outlined is-primary" @click="edit = true">
            <font-awesome-icon icon="edit" size="1x"/>
          </button>

          <button class="button is-outlined is-danger" @click="deleteEntry">
            <font-awesome-icon icon="trash-alt" size="1x"/>
          </button>
        </div>
      </td>
    </tr>
</template>

<script>
import moment from 'moment';
import { required, decimal, numeric } from 'vuelidate/lib/validators';
import UPDATE_GAS from '@/graphql/gas/updateGas.gql';
import DELETE_GAS from '@/graphql/gas/deleteGas.gql';

export default {
  name: 'GasTableRow',
  props: [
    'index',
    'initialRow',
  ],
  data() {
    return {
      row: this.initialRow,
      edit: false,
    };
  },
  validations: {
    row: {
      liters: {
        required,
        decimal,
      },
      price: {
        required,
        decimal,
      },
      odometer: {
        required,
        numeric,
      },
    },
    date: {
      required,
    },
  },
  computed: {
    date: {
      get() {
        return moment(this.row.date).format(moment.HTML5_FMT.DATETIME_LOCAL);
      },
      set(date) {
        this.row.date = moment(date).format('YYYY-MM-DD HH:mm:ss');
      },
    },
  },
  methods: {
    toggleEndOfSequence() {
      this.$apollo.mutate({
        mutation: UPDATE_GAS,
        variables: {
          id: this.row.id,
          endOfSequence: !this.row.end_of_sequence,
        },
      })
        .then((res) => {
          this.row = res.data.updateGas;
          this.$emit('refetch-list');
          this.$toasted.success('Entry updated');
        })
        .catch((error) => {
          this.$toasted.error(error);
        });
    },
    updateEntry() {
      this.$apollo.mutate({
        mutation: UPDATE_GAS,
        variables: {
          id: this.row.id,
          liters: this.row.liters,
          price: this.row.price,
          odometer: this.row.odometer,
          date: this.row.date,
        },
      })
        .then((res) => {
          this.edit = false;
          this.row = res.data.updateGas;
          this.$emit('refetch-list');
          this.$toasted.success('Entry updated');
        })
        .catch((error) => {
          this.$toasted.error(error);
        });
    },

    deleteEntry() {
      this.$root.$confirm.open(
        'Delete this row?',
        "This action can't be reverted, are you sure?",
      ).then((confirm) => {
        if (confirm) {
          this.$apollo.mutate({
            mutation: DELETE_GAS,
            variables: {
              id: this.row.id,
            },
          })
            .then(() => {
              this.$emit('refetch-list');
              this.$toasted.success('Entry deleted!');
            })
            .catch((error) => {
              this.$toasted.error(error);
            });
        }
      });
    },
    cancelEdit() {
      this.row = this.initialRow;
      this.edit = false;
    },
  },
};
</script>

<style scoped>
</style>
